
<div nz-row>
    <div nz-col>
        <img nz-image nzSrc="/public/assets/images/login_family.png" class="full-img-height login-fixed-image" />
    </div>
    <div nz-col class="message">
        <p>{{ maintenanceMessage }}</p>
    </div>
</div>
